import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-772ac5ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container_content" }
const _hoisted_3 = { class: "content_top" }
const _hoisted_4 = { class: "content_text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "频道logo:", -1))
const _hoisted_6 = { class: "content_watch" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "default_size" }, "建议大小为90*90，大小不能超过2M", -1))
const _hoisted_8 = { class: "content_text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "站点icon:", -1))
const _hoisted_10 = { class: "content_watch" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "default_size" }, "建议大小为32*32，大小不能超过2M", -1))
const _hoisted_12 = { class: "content_text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "导航栏logo:", -1))
const _hoisted_14 = { class: "content_watch" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "default_size" }, "建议大小为220*80，大小不能超过2M", -1))
const _hoisted_16 = { class: "content_text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "频道默认封面:", -1))
const _hoisted_18 = { class: "content_watch" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "default_size" }, "建议大小为1920*1080，大小不能超过2M(支持JPG,PNG,GIF)", -1))
const _hoisted_20 = { class: "content_text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "加载loading:", -1))
const _hoisted_22 = { class: "content_watch" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "default_size" }, "建议大小为120*120，大小不能超过2M(仅支持GIF格式)", -1))
const _hoisted_24 = { class: "text_upload" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "公众号二维码 : ", -1))
const _hoisted_26 = { class: "content_text" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "授权公众号Logo:", -1))
const _hoisted_28 = { class: "content_watch" }
const _hoisted_29 = { class: "content_text" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "授权弹窗标题:", -1))
const _hoisted_31 = { class: "content_watch" }
const _hoisted_32 = { class: "content_text" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "授权取消:", -1))
const _hoisted_34 = { class: "content_watch" }
const _hoisted_35 = { class: "content_text" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "授权允许:", -1))
const _hoisted_37 = { class: "content_watch" }
const _hoisted_38 = { class: "content_text" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "授权列表:", -1))
const _hoisted_40 = { class: "content_watch" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "content_text" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "公众号名称:", -1))
const _hoisted_44 = { class: "content_watch" }
const _hoisted_45 = { class: "content_text" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "版权设置:", -1))
const _hoisted_47 = { class: "content_watch" }
const _hoisted_48 = { class: "content_text" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "版权链接:", -1))
const _hoisted_50 = { class: "content_watch" }
const _hoisted_51 = { class: "content_text" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_head" }, "导航栏logo链接:", -1))
const _hoisted_53 = { class: "content_watch" }
const _hoisted_54 = { class: "footer_btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_upload = _resolveComponent("c-upload")!
  const _component_c_uploads = _resolveComponent("c-uploads")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_PlusCircleOutlined = _resolveComponent("PlusCircleOutlined")!
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_c_upload, {
              "file-list": _ctx.fileList,
              loading: _ctx.loading0,
              "handle-change": (info) => _ctx.handleChange(info, 0),
              "image-name": _ctx.obj.channelpicture,
              "click-stop": (info) => _ctx.imageDel(info, 0),
              class: "ant_upload ant_upload_img"
            }, null, 8, ["file-list", "loading", "handle-change", "image-name", "click-stop"]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_c_upload, {
              "file-list": _ctx.fileList,
              loading: _ctx.loading,
              "handle-change": (info) => _ctx.handleChange(info, 1),
              "image-name": _ctx.obj.siteicon,
              mask: false,
              uploadText: false,
              class: "ant_upload ant_upload_img1"
            }, null, 8, ["file-list", "loading", "handle-change", "image-name"]),
            _hoisted_11
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_c_upload, {
              "file-list": _ctx.fileList,
              loading: _ctx.loading2,
              "handle-change": (info) => _ctx.handleChange(info, 2),
              "image-name": _ctx.obj.Navigationlogo,
              "click-stop": (info) => _ctx.imageDel(info, 2),
              class: "ant_upload ant_upload_img2"
            }, null, 8, ["file-list", "loading", "handle-change", "image-name", "click-stop"]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_c_upload, {
              "file-list": _ctx.fileList,
              loading: _ctx.loading3,
              "handle-change": (info) => _ctx.handleChange(info, 3),
              "click-stop": (info) => _ctx.imageDel(info, 3),
              "image-name": _ctx.obj.defaultcover,
              class: "ant_upload ant_upload_img3"
            }, null, 8, ["file-list", "loading", "handle-change", "click-stop", "image-name"]),
            _hoisted_19
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_c_uploads, {
              "file-list": _ctx.fileList,
              loading: _ctx.loading4,
              "handle-change": (info) => _ctx.handleChange(info, 4),
              "click-stop": (info) => _ctx.imageDel(info, 4),
              "image-name": _ctx.obj.uploadLoading,
              class: "ant_upload ant_upload_img5",
              accept: ".gif"
            }, null, 8, ["file-list", "loading", "handle-change", "click-stop", "image-name"]),
            _hoisted_23
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_c_upload, {
            "file-list": _ctx.fileList,
            loading: _ctx.loading,
            "handle-change": _ctx.handleChange,
            "image-name": _ctx.obj.imageUrl,
            "click-stop": _ctx.imageDel,
            class: "ant_upload ant_upload_img4"
          }, null, 8, ["file-list", "loading", "handle-change", "image-name", "click-stop"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_c_upload, {
              "file-list": _ctx.fileList,
              "handle-change": (info) => _ctx.handleChange(info, 6),
              mask: false,
              uploadText: false,
              "image-name": _ctx.obj.wechat_public_avatar_url,
              class: "ant_upload ant_upload_img6",
              accept: ".jpg,.jpeg,.png"
            }, null, 8, ["file-list", "handle-change", "image-name"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.wechat_authorize_title,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.obj.wechat_authorize_title) = $event)),
              type: "small",
              placeholder: "请输入名称"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.wechat_authorize_btn[0],
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.obj.wechat_authorize_btn[0]) = $event)),
              type: "small",
              placeholder: "请输入名称"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.wechat_authorize_btn[1],
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.obj.wechat_authorize_btn[1]) = $event)),
              type: "small",
              placeholder: "请输入名称"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obj.wechat_authorize_list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "warrant_list"
              }, [
                _createVNode(_component_a_input, {
                  value: _ctx.obj.wechat_authorize_list[index],
                  "onUpdate:value": ($event: any) => ((_ctx.obj.wechat_authorize_list[index]) = $event),
                  type: "small",
                  placeholder: "请输入名称"
                }, null, 8, ["value", "onUpdate:value"]),
                _createElementVNode("span", {
                  class: "warrant_list_icon",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updataauthorizeList('add')))
                }, [
                  _createVNode(_component_PlusCircleOutlined)
                ]),
                _withDirectives(_createElementVNode("span", {
                  class: "warrant_list_icon",
                  onClick: ($event: any) => (_ctx.updataauthorizeList('del', index))
                }, [
                  _createVNode(_component_MinusCircleOutlined)
                ], 8, _hoisted_41), [
                  [_vShow, index > 0]
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.definition,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.obj.definition) = $event)),
              type: "small",
              placeholder: "请输入名称"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.PageFooter,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.obj.PageFooter) = $event)),
              type: "small",
              placeholder: "请输入页脚版权"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.copyright,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.obj.copyright) = $event)),
              placeholder: "请输入您的完整链接"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.catenate,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.obj.catenate) = $event)),
              placeholder: "请输入您的完整链接"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.keep
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}